import { VariationTypes, useEppoAssignment, SubjectKeyTypes } from '@vimeo/eppo';
import { useViewer } from '@vimeo/viewer';

export function useReportCommentTestAssignment() {
  const viewer = useViewer();
  const vuid = viewer?.vuid ?? 0;

  const { assignment } = useEppoAssignment({
    flagKey: 'video-comment-reporting',
    subject: {
      key: vuid,
      keyType: SubjectKeyTypes.VUID,
    },
    defaultAssignment: 'control',
    assignmentType: VariationTypes.STRING,
  });

  return assignment;
}
